<template>
  <v-modal id="modal-pai-team">
    <span slot="header">
      {{ i18nJS.team }}
    </span>
    <div class="row-fluid">
      <form class="form-horizontal">
        <div class="control-group">
          <label class="control-label" for="user_id">{{ i18nJS.user_label }}</label>
          <div class="controls">
            <v-select2
              :value="newPaisTeam['user_id']"
              :element_id.sync="newPaisTeam['user_id']"
              :element_description.sync="newPaisTeam['full_name']"
              :options-list="newPaisTeam.user_id ? [[newPaisTeam.full_name, newPaisTeam.user_id]] : []"
              :class="'input-xlarge'"
              :data-ajax--url="urlUsers"
              id="user_id"
            />
          </div>
        </div>
        <div class="control-group">
          <label class="control-label" for="notes">{{ i18nJS.notes }}</label>
          <div class="controls">
            <textarea v-model="newPaisTeam['notes']" rows="3" id="notes"></textarea>
          </div>
        </div>
      </form>
    </div>
    <button slot="footer" class="btn btn-success" href="javascript:void(0)" @click="savePaisTeam">
      {{ i18nJS.save }}
    </button>
  </v-modal>
</template>
<script>
import vModal from '../vModal';
import vSelect2 from '../vSelect2';

export default {
  name: 'modalTeam',
  components: {
    vSelect2,
    vModal,
  },
  props: ['urlUsers'],
  data() {
    return {
      error: false,
      newPaisTeam: {},
      jobDecodes: {},
      index: null,
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {
    eventBus.$on('openModalTeam', (result) => {
      this.newPaisTeam = result.data;
      this.index = result.index;
      $('#modal-pai-team').modal('show');
      Loader.hide();
    });
    eventBus.$on('jobDecodes', (job_decodes) => (this.jobDecodes = job_decodes));
    $('#modal-pai-team').on('hidden', () => {
      $('#user_id').trigger('change');
    });
    $('#user_id').on('change', (ev) => {
      var data_selected = $(ev.target).select2('data')[0];
      if (data_selected) {
        this.newPaisTeam['full_name'] = data_selected.text;
        this.newPaisTeam['user_id'] = data_selected.id;
        if (this.jobDecodes[data_selected.job]) {
          this.newPaisTeam['job'] = this.jobDecodes[data_selected.job]['desc'];
        }
      }
    });
  },
  methods: {
    savePaisTeam() {
      Loader.show();
      this.newPaisTeam['updated_who'] = window.config.user.id;
      if (!this.newPaisTeam.id) {
        this.newPaisTeam['created_who'] = window.config.user.id;
      }
      eventBus.$emit('savePaiTeam', { data: this.newPaisTeam, index: this.index });
    },
  },
};
</script>
